import { useTheme, css } from "@emotion/react";
import PropTypes from "prop-types";
import SlideWidget from './SlideWidget';
import SingleListWidget from './SingleListWidget';
import FlexListWidget from './FlexListWidget';
import FileWidget from './FileWidget';
import LinkWidget from './LinkWidget';
import ColumnWidget from './ColumnWidget';
import FlexImagesWidget from './FlexImagesWidget';
import CopyWidget from './CopyWidget';
import { em } from "@util/convertUnits";
import TableWidget from "./TableWidget";
import ApplicationOptionsWidget from "./ApplicationOptionsWidget";
import SwatchesTabsWidget from "./SwatchesTabsWidget";
import SwatchesWidget from "./SwatchesWidget";

const sectionMap = {
    "slides": SlideWidget,
    "single_list": SingleListWidget,
    "flex_list": FlexListWidget,
    "swatches": SwatchesTabsWidget,
    "swatches_single": SwatchesWidget,
    "flex_columns": ColumnWidget,
    "flex_images": FlexImagesWidget,
    "copy": CopyWidget,
    "table": TableWidget,
    "file": FileWidget,
    "link": LinkWidget,
    "image_list": ApplicationOptionsWidget

};

const SectionWidget = ({ section, name }) => {

    const theme = useTheme();
    const fontTheme = theme.header.fontFamily;

    const headerCss = css(`
        text-align:center;
        text-transform: uppercase;
        margin-top:2em;
    `);

    const sectionWidgetContainer = css(`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content:center;
    `);

    const sectionWidgetAnchor = css(`
        position: relative;
        top: -70px;
    `);

    const subtitleCss = css(`
        width:90%;
        margin:0 auto;
        height:auto;
        font-size: 1em;
        font-family: ${fontTheme};
        text-align:center;
        margin-bottom:2em;
        @media (min-width: ${em(theme.breakpoint.ns, 16)}) {
            text-align:center;
        }
    `);

    const componentWrapper = css(`
        align-items: center;
        flex-direction: column;
        display:flex;
        max-width: 90%;
        font-family: ${fontTheme};
        font-size: 1em;
        text-align: center;
        
        @media (min-width: ${em(theme.breakpoint.ns, 16)}) {
            justify-content: center;
            align-items: center;
            text-align: left;
        }
    `)

    const tabbedSwatches = section.content.filter((content)=>content.type==='swatches');

    const Components = section.content.map(content => {
        const key = JSON.stringify(content);
        const Component = sectionMap[content.type] || null;
        if(content.type === "link"){

            return (
                <div data-aos={"fade-up"} key={key}>
                    <LinkWidget content={content}/>
                </div>
            )

        } else if(content.type === "swatches"){

            return null;

        } else if (!Component) {

            return <div key={key}>
                <pre>{JSON.stringify(content, false, '\t')}</pre>
            </div>;

        } else {

            return (
                <div data-aos={"fade-up"} key={key}>
                    <Component content={content} />
                </div>
            )
        }
    })

    const subtitle = section.subtitle ?
        <div css={subtitleCss} dangerouslySetInnerHTML={{ __html: section.subtitle }}/> : false;

    /* eslint-disable */
    return <div css={sectionWidgetContainer}>
        <div css={sectionWidgetAnchor} id={name} />
        <h3 data-aos={"fade-up"} css={headerCss}>{section.rename || section.label}</h3>
        <div data-aos={"fade-up"} data-aos-delay={400} css={{width: '100%'}}>{subtitle}</div>
        {Components && <div css={componentWrapper}>{Components}</div>}
        {tabbedSwatches && <SwatchesTabsWidget tabs={tabbedSwatches}/>}
    </div>
    /* eslint-enable */
};

SectionWidget.propTypes = {
    section: PropTypes.object,
    name: PropTypes.string,
};


export { SectionWidget as default, sectionMap };